module.exports = __webpack_public_path__ + "static/media/return.5c178123.svg";